import { render, staticRenderFns } from "./addNationalAdmin.vue?vue&type=template&id=02d8047d&scoped=true&"
import script from "./addNationalAdmin.vue?vue&type=script&lang=js&"
export * from "./addNationalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addNationalAdmin.vue?vue&type=style&index=0&id=02d8047d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d8047d",
  null
  
)

export default component.exports